import { useEffect, useRef, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { useMediaQuery } from '../../../hooks/useMediaQuery';
import { useStores } from '../../../stores/useStores';

export const useBingoWindowWidthRedirect = () => {
  const { bingoStore, uiStore, subscriptionStore, wizardStore } = useStores();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const hasRedirectedRef = useRef(false);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const { bingoEnabled, currentOpenBingoEvent } = bingoStore;
  const { finishedCrownPrimeWelcomeTutorial } = subscriptionStore;
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    const shouldRedirectOnMobile = isMobile && pathname === '/bingo' && bingoEnabled && !currentOpenBingoEvent;

    if (shouldRedirectOnMobile && !hasRedirectedRef.current) {
      setIsRedirecting(true);
      hasRedirectedRef.current = true;
      navigate('/');
      bingoStore.openBingoFullPageDialog();
      if (!finishedCrownPrimeWelcomeTutorial) {
        wizardStore.forceStep(0);
      }
      return;
    }

    if (!bingoEnabled || currentOpenBingoEvent || !bingoStore.isInsideBingoArea) {
      setIsRedirecting(false);
      return;
    }

    // Handle resize: if switching from desktop to mobile
    if (isMobile && uiStore.openFullPageDialog === 'bingo') {
      setIsRedirecting(true);
      navigate('/');
      bingoStore.openBingoFullPageDialog();
      if (!finishedCrownPrimeWelcomeTutorial) {
        wizardStore.forceStep(0);
      }
      return;
    }

    // Handle resize: if switching from mobile to desktop and Bingo dialog is open
    if (!isMobile && uiStore.openFullPageDialog === 'bingo') {
      setIsRedirecting(false);
      navigate('/bingo');
      uiStore.setOpenFullPageDialog(null);
      return;
    }

    setIsRedirecting(false);
  }, [
    isMobile,
    uiStore.openFullPageDialog,
    uiStore,
    bingoEnabled,
    currentOpenBingoEvent,
    bingoStore,
    navigate,
    pathname,
    finishedCrownPrimeWelcomeTutorial,
    wizardStore,
  ]);

  return {
    isMobile,
    isDesktop: !isMobile,
    isRedirecting,
  };
};
